/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Draftemail_Validation_Scheduleinpast4Inputs */

const en_coinvestments_draftemail_validation_scheduleinpast4 = /** @type {(inputs: Coinvestments_Draftemail_Validation_Scheduleinpast4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send time must be in the future`)
};

/**
* | output |
* | --- |
* | "Send time must be in the future" |
*
* @param {Coinvestments_Draftemail_Validation_Scheduleinpast4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_draftemail_validation_scheduleinpast4 = /** @type {((inputs?: Coinvestments_Draftemail_Validation_Scheduleinpast4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Draftemail_Validation_Scheduleinpast4Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_draftemail_validation_scheduleinpast4(inputs)
});
export { coinvestments_draftemail_validation_scheduleinpast4 as "coInvestments_draftEmail_validation_scheduleInPast" }